/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { SET_MYELF_IN_ACTIVE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { featuresSection } from '../../config/featuresSection.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';

export interface ISetInactiveMethods extends IPluginMethodMap {
  setInActive(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class SetInactiveService implements IAgentPlugin {
  readonly methods: ISetInactiveMethods;

  constructor() {
    this.methods = {
      setInActive: this.setInActive.bind(this),
    };
  }

  async setInActive(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    const storageSrv = StorageModule.getInstance();
    const _localData = storageSrv.get('userProfile', 'local');
    const _sessionData = storageSrv.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client.mutation(SET_MYELF_IN_ACTIVE, {}).toPromise();
        console.log('profileress->', res, token);
        if (res?.data?.setMyselfInactive) {
          return {
            ...res?.data?.setMyselfInactive,
          };
        }

        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      throw err;
    }
  }
}
